// PostHog analytics client (third-party product analytics).
// Separate from lib/api/analytics.ts which is the custom builder funnel tracker.
import posthog from 'posthog-js'

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_API_KEY
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_API_HOST || 'https://us.i.posthog.com'

export function initPostHog(): typeof posthog | undefined {
  if (!POSTHOG_KEY) return undefined

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: false,
    capture_pageleave: false,
    persistence: 'localStorage+cookie',
  })

  return posthog
}

export { posthog }
